import { useSelector } from 'react-redux'
import { editorSelectors } from 'store/features/editor/selectors'
import { aiVideoSelectors } from 'store/features/aiVideo/selectors'
import GenerationHistory from './GenerationHistory'
import VersionHistory from './VersionHistory'

const HistoryTab = () => {
  const activeTimelineItemId = useSelector(editorSelectors.activeTimelineItemId)
  const showVersionHistoryTab = useSelector(
    aiVideoSelectors.showVersionHistoryTab
  )
  const hasSelectedItem = !!activeTimelineItemId

  return hasSelectedItem || showVersionHistoryTab ? (
    <VersionHistory />
  ) : (
    <GenerationHistory />
  )
}

export default HistoryTab
